import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  CategoryPageMetaResolver,
  PageMetaResolver,
  ProductEventModule,
  ProductPageMetaResolver
} from "@spartacus/core";
import { CustomCategoryPageMetaResolver } from 'src/app/services/product/custom-category-page-meta.resolver';
import { CustomFamiliesPageMetaResolver } from 'src/app/services/product/custom-families-page-meta.resolver';
import { CustomProductPageMetaResolver } from 'src/app/services/product/custom-product-page-meta.resolver';
import { CustomCouponSearchPageResolver } from './services/custom-coupon-search-page-meta.resolver';
import { CustomProductStoreModule } from "./store/custom-product-store.module";


const pageTitleResolvers = [
  {
    provide: ProductPageMetaResolver,
    useExisting: CustomProductPageMetaResolver,
    multi: false,
  },
  {
    provide: PageMetaResolver,
    useExisting: CustomCouponSearchPageResolver,
    multi: true,
  },
  {
    provide: CategoryPageMetaResolver,
    useExisting: CustomCategoryPageMetaResolver,
    multi: false,
  },
  {
    provide: PageMetaResolver,
    useExisting: CustomFamiliesPageMetaResolver,
    multi: true,
  },
];

@NgModule({
  providers: pageTitleResolvers,
  imports: [CustomProductStoreModule, ProductEventModule],
})
export class CustomProductModule {
  static forRoot(): ModuleWithProviders<CustomProductModule> {
    return {
      ngModule: CustomProductModule
    };
  }
}
